export default __webpack_public_path__ + "img/icomoon.11dfb7edcd89e8e9bd3bc888307ebff0.svg";